/***
 *
 *
 * @description
 * @author Ashique Mohammed
 * Custom  componet used for Document upload
 *
 *
 */

import React, { useState } from 'react';

import { Modal} from 'antd';

import { DocumentUpload } from './../emr-screen/documents/documents';

import { Button } from 'soxo-bootstrap-core';
import ConsentUploader from '../../../../components/consent-uploader/consent-uploader';

/**
 *
 * @param {*} param0
 * @returns
 */
export default function DocumentUploadComponent({
    title = 'Documents',

    referenceId,
    referenceNumber,
    reportConfig,

    props,
    guest,
    onPremiseUrl
}) {
    let [visible, setVisible] = useState(false);
    return (
        <div className="head-selector">
            <Button
                className="billing"
                onClick={() => {
                    setVisible(true);
                }}
                // type="secondary"
                // shape="round"
                size="small"
                color="green"
                type='primary'
            >
                {/* <i class="fas fa-file"></i>  */}
                {title}
            </Button>

            <Modal
                destroyOnClose={true}
                visible={visible}
                // title='Advance Search'
                footer={null}
                className=""
                onCancel={() => {
                    setVisible(false);
                    //setResult(null);
                }}
                width={'45%'}
                maskClosable={false}
            >

                <ConsentUploader
                    da_id={guest.da_id}
                    billId={guest.bill_id}
                    op_no={guest.op_no}
                    documentMode={props.documentMode}
                    documentCode={props.documentCode}
                    isNuradesk={props.isNuradesk}
                    onPremiseUrl={onPremiseUrl}
                    fileUploadExtensionSupport={props.fileUploadExtensionSupport}
                    maxFileUploadSize={props.maxFileUploadSize}
                    props={props}
                    callback={() => setVisible(false)}
                />




            </Modal>
        </div>
    );
}
